import Icon from '../components/Icon.vue'

Icon.register({
  'hand-holding-heart': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M275.3 250.5l-108.9-114.2c-31.6-33.2-29.7-88.2 5.6-118.8 30.8-26.7 76.7-21.9 104.9 7.8l11.1 11.6 11.2-11.7c28.2-29.6 74.1-34.4 104.9-7.7 35.4 30.6 37.2 85.6 5.6 118.8l-108.9 114.2c-7.1 7.4-18.5 7.4-25.5 0zM565.3 328.1c15.1 13.6 13.9 36.8-1.3 48.9l-151.2 121c-11.4 9.1-25.5 14-40 14h-356.8c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h55.4l46.5-37.7c21-17 47.1-26.3 74.1-26.3h160c19.5 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.3 26.6h-78.3c-8.8 0-16 7.2-16 16s7.2 16 16 16h118.3c14.6 0 28.7-4.9 40-14l92.4-73.9c12.4-10 30.8-10.7 42.6 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/hand-holding-heart.js
// module id = 1421
// module chunks = 0